import { ArrowLeftModal } from '~/icons';
import { useTranslation } from 'react-i18next';
import { ModalTemplate } from '../ModalTemplate';

interface ExitModalProps {
  isOpen: boolean;
  onClose: () => void; // Fechar o modal
  onExit: () => void; // Sair da página
}

export const ModalExitWithoutSaving: React.FC<ExitModalProps> = ({ isOpen, onClose, onExit }) => {
  const { t } = useTranslation();
  return (
    <ModalTemplate
      isOpen={isOpen}
      onClose={onClose}
      text={t('desejaRealmenteSairDaPagina')}
      title={t('sairDaPagina')}
      iconTitle={<ArrowLeftModal />}
      button1={t('sairSemSalvar')}
      button2={t('cancelar')}
      button1Action={onExit}
      button2Action={onClose}
    />
  );
};
